// CalendarComponent.js
import React, { useEffect, useState } from "react";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import getDay from "date-fns/getDay";
import "react-big-calendar/lib/css/react-big-calendar.css";
import enUS from "date-fns/locale/en-US";
import { Stack } from "@mui/material";
import { useUser } from "../Contexts/UserContext";
import { GetApp } from "@mui/icons-material";
import moment from "moment";
import GetDate from "./GetDate";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;

const locales = {
  "en-US": enUS,
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});
function convertDateString(inputString) {
  const parts = inputString.split(" ");
  const dateParts = parts[0].split("-");
  // const timeParts = parts[1].split(":");
  // Return a Date object directly instead of converting it to a string
  console.log(
    parseInt(dateParts[2], 10),
    parseInt(dateParts[1], 10), // Month is 0-indexed
    parseInt(dateParts[0], 10)
  );
  const temp = new Date(
    parseInt(dateParts[2], 10),
    parseInt(dateParts[1], 10) - 1, // Month is 0-indexed
    parseInt(dateParts[0], 10)
    // parseInt(timeParts[0], 10),
    // parseInt(timeParts[1], 10),
    // parseInt(timeParts[2], 10)
  );
  console.log(temp);
  return temp;
}
function formatDateWithMoment(inputString) {
  return moment(new Date(inputString)).format("YYYY-MM-DD");
}

const EventCalendar = () => {
  const [events, setEvents] = useState([]);
  const { user } = useUser();
  const structureData = (arr) => {
    const newEvents = arr.map((element) => ({
      start: new Date(element.EventStartDate),
      end: new Date(element.EventEndDate),
      title: element.EventName,
    }));
    setEvents(newEvents); // Update state once with the new array
  };
  const date = GetDate();
  useEffect(() => {
    const fetchInitData = async () => {
      const response = await fetch(
        `${API_URL}/facility/get-events/1/${user.CompCode}/${user.ClientId}/NA/NA/${date}/${date}`
      ).then((res) => res.json());
      console.log(response);
      if (response.success) {
        structureData(response.data);
      } else {
        alert("Failed to fetch events :(");
      }
    };
    fetchInitData();
  }, []);
  const handleSelectEvent = (event) => {
    alert(`Event: ${event.title}`);
  };
  const handleSelectSlot = async ({ start, end }) => {
    const title = window.prompt("New Event Name");
    let st = formatDateWithMoment(start);
    let en = formatDateWithMoment(end);
    if (title) {
      let res = await fetch(
        `${API_URL}/facility/get-events/2/${user.CompCode}/${user.ClientId}/NA/${title}/${st}/${en}`
      ).then((res) => res.json());
      setEvents([...events, { title, start, end }]);
    }
  };

  return (
    <div style={{ padding: "1rem 2rem" }}>
      <Stack mt={1} mb={1} pl={5} textAlign="start">
        <h2
          className="heading2"
          style={{
            fontSize: "14px",
            fontWeight: "500",
            padding: "0",
            lineHeight: "1px",
            margin: "0px 0px 0px 0vw",
            letterSpacing: "2px",
            textTransform: "uppercase",
            color: "#aaaaaa",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          Event
          <style>
            {`
      .heading2::after {
        content: "";
    width: 120px;
    height: 1px;
    display: inline-block;
    background: #1F51FF;
    margin: 4px 10px;
      }
    `}
          </style>
        </h2>
      </Stack>
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 500, margin: "50px" }}
        onSelectEvent={handleSelectEvent}
        selectable
        onSelectSlot={handleSelectSlot}
      />
    </div>
  );
};

export default EventCalendar;
